export enum EModeleMultimetre {
    M400 = 1,
    M440,
    AMI310,
    AMI300,
    Velocicalc9565,
    Accubalance8380,
}